import girlPicture from "images/le-club/vision/why-girl.webp";

import { StaticImage } from "ui/StaticImage";
import { useI18n } from "utils/with-i18n.utils";

export const Vision = () => {
  const i18n = useI18n();

  return (
    <section className="flex justify-center bg-cornflower-blue">
      <article className="flex flex-col items-center py-16 max-w-7xl text-white lg:py-24">
        <p className="w-fit text-4xl font-bold text-center lg:mb-12 lg:text-6xl lg:whitespace-nowrap">
          {i18n.t("club.why.title1")}
          <br className="lg:hidden" />
          {i18n.t("club.why.title2")}
          <br />
          {i18n.t("club.why.title3")}
        </p>

        <div className="flex flex-col w-full lg:flex-row-reverse">
          <div className="relative my-8 w-full h-48 lg:basis-4/5 lg:my-0 lg:h-80">
            <StaticImage
              src={girlPicture}
              alt="decorative girl image"
              layout="fill"
              sizes="(max-width: 1024px) 75vw, 33vw"
              placeholder="blur"
              objectFit="contain"
            />
          </div>
          <div className="px-7 lg:px-0">
            <p>{i18n.t("club.why.description.part1")}</p>
            <p>{i18n.t("club.why.description.part2")}</p>
            <p className="mt-6 font-semibold text-yellow">
              {i18n.t("club.why.description.part3")}
            </p>
            <p>{i18n.t("club.why.description.part4")}</p>
            <p className="my-6">{i18n.t("club.why.description.part5")}</p>
            <p>
              {i18n.t("club.why.description.part6")}
              <span className="font-semibold text-yellow">
                {i18n.t("club.why.description.part7")}
              </span>
            </p>
          </div>
        </div>
      </article>
    </section>
  );
};
